import { ServiceStore } from "@intrasync/stores";
import type { RouteType } from "../../../types/RouteType";

const YardTrailersRoute: RouteType = {
    name: "Yard Trailers",
    path: "/yard/trailers/:tab?",
    defaultParams: { tab: "overview" },
    layout: "/app",
    viewportCard: {
        header: {
            component: () => import("./YardTrailers.Header"),
            title: "Trailer Management",
            color: "primary",
            enableRefreshButton: true,
            enableBackButton: true,
        },
        body: {
            component: () => import("./YardTrailers.Body"),
            grayBackground: true,
        },
    },
    group: 'Yard',
  requiresAuth: true,
    requiresPermission: false,
    beforeEnter: async ({ rootStore }: any) => {
        try {
            const trailerStore = rootStore.trailerStore as ServiceStore;
            const yardLocationsStore = rootStore.yardLocationsStore as ServiceStore;
            const yardInventoryItemsStore = rootStore.yardInventoryItemsStore as ServiceStore;

            await Promise.all([
                trailerStore.find({ query: { $limit: 100 } }),
                yardLocationsStore.find({ query: { $limit: 50 } }),
                yardInventoryItemsStore.find({ query: { $limit: 50 } }),
            ]);
            return true;
        } catch (error) {
            console.error("Error loading trailer data:", error);
            return false;
        }
    },
    onParamsChange: async ({ rootStore }: any) => {
        const routerStore = rootStore.routerStore;
        const tab = routerStore.params?.tab;
        console.log(`Trailers tab changed to: ${tab}`);
    },
    // Temporarily disabled until dialog implementation is updated
    // dialogs: [
    //     {
    //         name: "Add Trailer",
    //         component: () => import("../YardDialogs/AddTrailer.Dialog"),
    //         title: "Add New Trailer",
    //         onSubmit: async ({ rootStore }: any) => {
    //             const trailerStore = rootStore.trailerStore as ServiceStore;
    //             await trailerStore.find({ query: { $limit: 100 } });
    //             return true;
    //         },
    //         onSubmitValidation: ({ rootStore }: any) => {
    //             return true;
    //         },
    //         cancelButton: true,
    //         height: 600,
    //     },
    // ],
};

export default YardTrailersRoute;
